import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useHistoryListFetch = (id: string) => {
  const response = useQuery({
    queryKey: ['paymentHistory', id],
    queryFn: () => api.payments.fetchHistory(id),
    enabled: !!id,
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить историю',
      type: 'error',
    })
  }

  return response
}
